<template>
  <Wrap
    :title="$t('web_app.homeNotice.notice')"
    @closeClick="handleCloseClick"
    :show_clearAll="true"
    @clearAllClick="markAll"
  >
    <ScrollView :height="windowInnnerHeight" class="messageList">
      <NoticeList />
    </ScrollView>
  </Wrap>
</template>

<script>
import api from 'api'
import Wrap from './Wrap.vue'
import { ScrollView } from '../UI/scrollView'
import NoticeList from '../NoticeList.vue'
import logClickEvent from '@utils/logClickEvent'
export default {
  data() {
    return {
      windowInnnerHeight:
        parseInt(window.innerHeight * 0.7) > 800 ? '800px' : parseInt(window.innerHeight * 0.7) + 'px',
    }
  },
  components: {
    Wrap,
    ScrollView,
    NoticeList,
  },

  methods: {
    markAll() {
      logClickEvent('首页消息列表', '全部已读')
      api.call('POST', '/notification/mark_all_as_read', {}, (response) => {
        if (response.data && response.data.code === 0) {
          for (let i in this.$store.state.notifications) {
            let notification = this.$store.state.notifications[i]
            notification.readed = true
          }
        }
      })
    },
    handleCloseClick() {
      this.$emit('close-click')
    },
  },
}
</script>
<style scoped>
.notifications {
  margin: 0 10px;
}
</style>
<style>
.messageList {
  margin-top: -10px;
}
.messageList .notifications .notification {
  background: var(--noticeListItemBg) !important;
}

.messageList .notification.readed .content {
  color: #9d9d9d;
}
</style>
